module.exports = __webpack_public_path__ + "img/calendario-icon.fdf5b34.svg";